const getCode = (params) => {
  const routeObject = {
    default: [],
    Guest: 301,
    Parent: 302,
    Student: 303,
    Teacher: 304,
    Admin: 305,
    HeadMaster: 306,
    ContentManager: 307,
    Government: 308,
    AdministrationStaff: 309,
    Sales: 310,
    Finance: 311,
    Marcomm: 312,
    Support: 313,
    Trainer: 314,
    HomeroomTeacher: 315,
    Librarian: 316,
    LibraryStaff: 317,
    Academic: 318,
    SA: 999,
    Mitra: 366,
    Supervisor: 367,
  };

  return routeObject[params || 'default'];
};
export default getCode;
